import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AppThemeProvider } from './theme';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element with id "root" not found');
}
const root = ReactDOM.createRoot(rootEl);
root.render(
  <AppThemeProvider>
    <App />
  </AppThemeProvider>
);
